import React, { createContext, useContext, useState, useEffect } from "react";

// Define your context
const SessionContext = createContext();

// Custom hook to access session context
export const useSession = () => useContext(SessionContext);

// Provider component to wrap your app and manage session state
export const SessionProvider = ({ children }) => {
    const [sessionData, setSessionData] = useState(() => {
        const data = {
            contextTournament: JSON.parse(sessionStorage.getItem("contextTournament")) || {},
        };
        return data;
    });

    // Function to update a specific session key
    const updateSessionData = (key, data) => {
        setSessionData(prevData => {
            const updatedData = { ...prevData, [key]: data };
            if (data === undefined) {
                sessionStorage.removeItem(key);
            }
            else {
                sessionStorage.setItem(key, JSON.stringify(data));
            }
            return updatedData;
        });
    };

    return (
        <SessionContext.Provider value={{ sessionData, updateSessionData }}>
            {children}
        </SessionContext.Provider>
    );
};
